import React from 'react';
import MainLayout from '../components/MainLayout';
import { Link } from 'react-router-dom';
import whoweare from '../assets/images/img/who-we-are.jpg';
import Accordion from 'react-bootstrap/Accordion';

export default function TravelTourismCorpPortal() {
  return (
    <>
    <MainLayout>

    <div className='breadcrumb_area'>
    <div className='photo'>
    <img src={whoweare} alt=''/>
      <div className='wrapper'> 
          <div className='container'>
          <div className='row'>
          <div className='col-12'>
          <h1 className='breadcrumb_title'>Travel & Tourism Corporate Booking Portal</h1>
          <ul className="breadcrumb_list">
          <li className="breadcrumb_item"><Link to='/'>Home</Link></li>
          <li className="breadcrumb_item">Travel & Tourism Corporate Booking Portal</li>                 
          </ul>
          </div>
          </div>
          </div>  
      </div>
    </div>
    </div>

    <div className='inner_page_content digital_marketing travel_tourism_b2b'> 
      <div className='container'>

          <div className='row'>
        
          {/* <div className='col-12'>
              <h2>Corporate Module Functionality </h2>
              
              <p>We specialize in delivering mobile app development services that help businesses create innovative, user-friendly, and high-performance mobile applications. Whether you're looking to develop an app for iOS, Android, or cross-platform, our team of expert developers provides end-to-end mobile app solutions tailored to your business needs.</p>
        
        <h4>Our Mobile App Development Process:</h4>
        
          </div> */}

<div className='col-12'>

<Accordion defaultActiveKey="0">

<Accordion.Item eventKey="0">
  <Accordion.Header>Corporate Module Functionality</Accordion.Header>
  <Accordion.Body>

<ul>
<li>Self-Booking Tool for Employees(Traveler), Booker or Admin & Travel Desk</li>
<li>Multi Product Search & Book capability, Multi Air, Hotel, Car & Other Products Supplier connectivity (GDS, LCC, NDC, Consolidators, Hotel Suppliers, Car Suppliers & Other Ancillary Supplier integrations.)</li>
<li>Corporate Profiling & Hierarchy.</li>
<li>Policy Compliance</li>
<li>Multi-level Approval Workflow</li>
<li>Corporate Credit & Billing Policy</li>
<li>Form of Payment Setup (Card, Invoice, Advance Payment etc.)</li>
<li>PNR Structuring</li>
<li>Defining Mark-ups, Commission & Transaction Fee based on Agreement</li>
<li>Defining Promo Code, Corporate Code, Tour Code, Account Code & Deal management.</li>
<li>Import & Process External Bookings.</li>
<li>Create Passive Bookings for LCC & land products.</li>
<li>Corporate Reporting Fields Configuration.</li>
<li>Expense Management</li>
<li>Business Intelligence Dashboard</li>
<li>Loss saving Reports, Purchase Reports, Expense Reports, Sales Reports</li>
<li>Cross-sell Ancillary Services like Lounges, Restaurants, Cab(Uber) etc.</li>
<li>Duty of Care & Employee Tracking.</li>
<li>Corporate Administrator Reports, Sales Reports, In-Policy & Out Policy Bookings Report, Top Airlines, Destination Reports, Advance Purchase Reports.</li>

</ul>

  </Accordion.Body>
</Accordion.Item>


<Accordion.Item eventKey="1">
  <Accordion.Header>Integrations</Accordion.Header>
  <Accordion.Body>
  <ul>
 
    <li> Profile Integrations with Corporate HR ERP.</li>
    <li>Invoice Integrations with Corporate Finance ERP.</li>
    <li>Any third party Profile Management Tool & Approval Tool Integrations based on Corporate Requirements.</li>
  </ul>
  </Accordion.Body>
</Accordion.Item>


</Accordion>

</div>

          </div>

      </div>
    </div>

    </MainLayout>
    </>
  )
}
